import React, { useEffect } from "react";
import TrackItem from "./TrackItem";

const Track = ({
  track,
  setSelectOption,
  selectOption,
  stateTracks,
  getRacesTrack,
  getEntriesRace,
  trackOption,
  openTracks,
  status,
}) => {
  useEffect(() => {
    if (openTracks && openTracks.length !== 0) {
      if (openTracks.includes(track.TrackID)) {
        document
          .getElementById("idCollapse" + parseInt(track.TrackID, 10))
          .classList.add("show");
      } else {
        document
          .getElementById("idCollapse" + parseInt(track.TrackID, 10))
          .classList.remove("show");
      }
    }
  }, [openTracks]);

  const getRaces = (TrackID) => {
    getRacesTrack(
      TrackID,
      track?.UpcomingRace?.RaceID || 0,
      status,
      track?.UpcomingRace?.RaceStatus || ""
    );
    setSelectOption(
      track.TrackID,
      track.TrackName,
      track?.UpcomingRace?.RaceID || 0,
      track?.UpcomingRace?.RaceNumber || 0,
      track.TrackCode,
      track?.UpcomingRace?.RaceStatus || "",
      status
    );
  };

  let trackStatus;

  if (track?.UpcomingRace?.RaceNumber !== 0 && !track?.Complete) {
    trackStatus = <>R{track?.UpcomingRace?.RaceNumber}</>;
  } else if (track?.Complete) {
    trackStatus = <i className="fas fa-check" style={{ color: "#28a745" }}></i>;
  }

  return (
    <>
      <li className="nav-item pcoded-hasmenu pcoded-collap active pcoded-trigger">
        <a
          className="nav-link"
          data-toggle="collapse"
          href={"#idCollapse" + track.TrackID}
          role="button"
          aria-expanded="false"
          aria-controls={"idCollapse" + track.TrackID}
          onClick={() => getRaces(track.TrackID)}
        >
          <span className="form-group">
            <label
              className="inline-group"
              style={{
                fontSize: "16px",
                whiteSpace: "normal",
                width: "170px",
                margin: "0px",
              }}
            >
              <span style={{ color: "#1cc8e3", fontWeight: "bold" }}>
                {track.TrackCode}
              </span>{" "}
              {track.TrackName}
            </label>
            <label
              className="inline-group"
              style={{ float: "right", marginRight: "22px" }}
            >
              {trackStatus}
            </label>
          </span>
        </a>
        <div className="collapse" id={"idCollapse" + track.TrackID}>
          <ul className="pcoded-submenu">
            {trackOption.Races &&
              trackOption.Races.map((race) => (
                <TrackItem
                  key={race.RaceID}
                  race={race}
                  track={track}
                  setSelectOption={setSelectOption}
                  selectOption={selectOption}
                  getEntriesRace={getEntriesRace}
                />
              ))}
          </ul>
        </div>
      </li>
    </>
  );
};

export default Track;
